import { RESET as RESET_ADDONS } from '../actions/addons'
import { PAY_NOW_SUCCESS } from '../actions/checkout'
import {
  DISMISS_ERROR,
  FETCH_CURRENT_SUBSCRIPTIONS_FAILURE,
  FETCH_CURRENT_SUBSCRIPTIONS_SUCCESS,
  INIT_APP_REQUEST
} from '../actions/checkout-app'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'
import { RESET as RESET_PACKAGES } from '../actions/packages'

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  currentSubscriptions: []
}

const appReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case FETCH_CURRENT_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
        currentSubscriptions: action.payload.subscriptions
      }
    case FETCH_CURRENT_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        hasError: true,
        errorMessage: action.payload instanceof Error && action.payload.message !== '' ? action.payload.message : 'An error occurred while trying to load current subscriptions'
      }

    case INIT_APP_REQUEST:
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case DISMISS_ERROR:
    case RESET_ADDONS:
    case RESET_PACKAGES:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}

export default appReducer
